import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "commons/store/store";
import axiosPublicInstance from "commons/axios/axiosPublicInstance";

export interface AgreementState {
  data: any;
}

const initialState: AgreementState = {
  data: [],
};

export const fetchAgreements = createAsyncThunk(
  'agreement/fetchAgreements',
  async (type: any, thunkAPI) => {
    try {
      const response = await axiosPublicInstance.get<any[]>(
        type ? `/api/agreements?type.name=${type}` : `/api/agreements`
      );
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const agreementSlice = createSlice({
  name: "agreement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAgreements.fulfilled, (state, action) => {
      state.data = action.payload;
    });
  },
});

export const selectAgreements = (state: RootState) => state.core.agreement.data;

export default agreementSlice.reducer;
